// Cookie helper functions

export const getCookie = (name: string): string | undefined => {
    const nameEQ = `${name}=`;
    const cookie = document.cookie.split("; ").find((c) => c.startsWith(nameEQ));
    return cookie ? cookie.substring(nameEQ.length) : undefined;
};

export const setCookie = (name: string, value: string, days: number) => {
    const expires = days ? `; expires=${new Date(Date.now() + days * 86400000).toUTCString()}` : "";
    document.cookie = `${name}=${value || ""}${expires}; path=/`;
};
